"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _SimpleDate = require("../../core/SimpleDate");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _SimpleDateTypes = require("../../types/SimpleDateTypes");

var _Month = _interopRequireDefault(require("./Month"));

var _UIIconButton = _interopRequireDefault(require("../../button/UIIconButton"));

var _UIIcon = _interopRequireDefault(require("../../icon/UIIcon"));

var _calendarUtils = require("./calendarUtils");

var _Locale = require("../../utils/Locale");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "CalendarPage__Wrapper",
  componentId: "sc-11ngfql-0"
})(_templateObject());
/**
 * @param {SimpleDate} value The current selected date, or null
 * @returns {String} A string for announcing the selected date to screen readers
 */


var getAlertText = function getAlertText(value) {
  return value ? _I18n.default.text('ui.datePicker.dateSelected', {
    date: (0, _SimpleDate.toMoment)(value).format('LL')
  }) : _I18n.default.text('ui.datePicker.noDateSelected');
};

var CalendarPage =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(CalendarPage, _PureComponent);

  function CalendarPage() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CalendarPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CalendarPage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handlePrevClick = function () {
      var _this$props = _this.props,
          calendarPage = _this$props.calendarPage,
          onCalendarPageChange = _this$props.onCalendarPageChange,
          today = _this$props.today,
          value = _this$props.value;
      var currentCalendarPage = calendarPage || (0, _calendarUtils.getPageFromDate)(value || today);
      onCalendarPageChange((0, _SyntheticEvent.default)((0, _calendarUtils.prevCalendarPage)(currentCalendarPage)));
    };

    _this.handleNextClick = function () {
      var _this$props2 = _this.props,
          calendarPage = _this$props2.calendarPage,
          onCalendarPageChange = _this$props2.onCalendarPageChange,
          today = _this$props2.today,
          value = _this$props2.value;
      var currentCalendarPage = calendarPage || (0, _calendarUtils.getPageFromDate)(value || today);
      onCalendarPageChange((0, _SyntheticEvent.default)((0, _calendarUtils.nextCalendarPage)(currentCalendarPage)));
    };

    return _this;
  }

  (0, _createClass2.default)(CalendarPage, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          calendarPage = _this$props3.calendarPage,
          id = _this$props3.id,
          locale = _this$props3.locale,
          __onCalendarPageChange = _this$props3.onCalendarPageChange,
          today = _this$props3.today,
          value = _this$props3.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["calendarPage", "id", "locale", "onCalendarPageChange", "today", "value"]);
      var localeData = (0, _Locale.getLocaleData)(locale);

      var _ref = calendarPage || (0, _calendarUtils.getPageFromDate)(value || today),
          month = _ref.month,
          year = _ref.year;

      return _react.default.createElement(Wrapper, {
        id: id
      }, _react.default.createElement("span", {
        className: "sr-only",
        "aria-live": "assertive"
      }, getAlertText(value)), _react.default.createElement(_Month.default, (0, _extends2.default)({}, rest, {
        month: month,
        monthNames: localeData._months,
        leftControl: _react.default.createElement(_UIIconButton.default, {
          "data-action": "prev-month",
          use: "transparent",
          tabIndex: -1,
          "aria-hidden": true,
          onClick: this.handlePrevClick
        }, _react.default.createElement(_UIIcon.default, {
          name: "left",
          size: 22
        })),
        ownerId: id,
        rightControl: _react.default.createElement(_UIIconButton.default, {
          "data-action": "next-month",
          use: "transparent",
          tabIndex: -1,
          "aria-hidden": true,
          onClick: this.handleNextClick
        }, _react.default.createElement(_UIIcon.default, {
          name: "right",
          size: 22
        })),
        today: today,
        weekdayHeadings: localeData._weekdaysMin,
        weekStartDay: localeData._week.dow,
        value: value,
        year: year
      })));
    }
  }]);
  return CalendarPage;
}(_react.PureComponent);

CalendarPage.displayName = 'CalendarPage';

if (process.env.NODE_ENV !== 'production') {
  CalendarPage.propTypes = {
    calendarPage: _propTypes.default.shape({
      year: _propTypes.default.number.isRequired,
      month: _propTypes.default.number.isRequired
    }),
    id: _propTypes.default.string.isRequired,
    locale: _propTypes.default.string,
    onCalendarPageChange: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func.isRequired,
    today: _SimpleDateTypes.SimpleDateType.isRequired,
    value: _SimpleDateTypes.SimpleDateType
  };
}

var _default = CalendarPage;
exports.default = _default;
module.exports = exports.default;